module.exports = __webpack_public_path__ + "img/motorcycle-photo-02.51d71c27.jpg";